var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85938 4.33211V6.54172M6.85938 8.75133H6.86512M5.87737 1.49276L1.01329 9.30373C0.913004 9.47079 0.859941 9.66019 0.85938 9.8531C0.858818 10.046 0.910778 10.2357 1.01009 10.4033C1.1094 10.5709 1.2526 10.7106 1.42545 10.8084C1.5983 10.9062 1.79476 10.9588 1.99529 10.9609H11.7235C11.924 10.9588 12.1205 10.9062 12.2933 10.8084C12.4661 10.7106 12.6093 10.5709 12.7087 10.4033C12.808 10.2357 12.8599 10.046 12.8594 9.8531C12.8588 9.66019 12.8057 9.47079 12.7055 9.30373L7.84138 1.49276C7.739 1.33041 7.59486 1.19619 7.42285 1.10303C7.25084 1.00988 7.05677 0.960938 6.85938 0.960938C6.66198 0.960938 6.46791 1.00988 6.2959 1.10303C6.12389 1.19619 5.97975 1.33041 5.87737 1.49276Z",
    stroke: "#C2510A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.8c7b682e1383fb2670534b865f89650e.svg";
export { ForwardRef as ReactComponent };